<ion-card>
    <ion-card-content>
        <ion-label><h1>Demonstration?</h1></ion-label>
        <ion-list lines="none">
            <ion-radio-group (ionChange)="checkOption($event)">
                <ion-item [color]="selectColor(1)">
                    <ion-radio mode="ios" slot="end" value="1"></ion-radio>
                    <ion-label>Given</ion-label>
                </ion-item>
                <ion-item [color]="selectColor(2)">
                    <ion-label>Refused</ion-label>
                    <ion-radio mode="ios" slot="end" value="2"
                               class="radio-item"></ion-radio>
                </ion-item>

                <ion-item [color]="selectColor(3)">
                    <ion-radio mode="ios" slot="end" value="3" checked></ion-radio>
                    <ion-label>N/A</ion-label>
                </ion-item>
            </ion-radio-group>
        </ion-list>
    </ion-card-content>
    <ion-card-content>
        <ion-label><h1>Personal Protective Equipment Taken?</h1></ion-label>
        <ion-list lines="none">
            <ion-radio-group (ionChange)="checkOption($event)">
                <ion-item [color]="selectColor(4)">
                    <ion-radio mode="ios" slot="end" value="4"></ion-radio>
                    <ion-label>Given</ion-label>
                </ion-item>

                <ion-item [color]="selectColor(5)">
                    <ion-radio mode="ios" slot="end" value="5"></ion-radio>
                    <ion-label>Refused</ion-label>
                </ion-item>

                <ion-item [color]="selectColor(6)">
                    <ion-radio mode="ios" slot="end" value="6" checked></ion-radio>
                    <ion-label>N/A</ion-label>
                </ion-item>
            </ion-radio-group>
        </ion-list>
    </ion-card-content>
</ion-card>

<ion-fab vertical="bottom" horizontal="end" slot="fixed">
    <ion-fab-button (click)="saveQuestions()" color="success">
        <ion-icon name="checkmark"></ion-icon>
    </ion-fab-button>
</ion-fab>
